import request from '@/config/axios';

/**
 * HomeGetAppInfoList
 * 获取应用列表
 * @return Array {}
 */
export function HomeGetAppInfoList(data) {
  return request({
    url: '/appinfo/getHotAppInfoList',
    method: 'GET',
    params: data
  });
}
export function HomeGetIndexDocInfo(data) {
  return request({
    url: '/opendoc/preview/getIndexDocInfo',
    method: 'GET',
    params: data
  });
}
